import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import PaginationCM from "components/shared/Pagination";
import { getViewProductsRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Button from "@mui/material/Button";

const headCells = GenarateHeadCell("views");
let initialPage = 1;

export default function Products() {
  const [products, setProducts] = useState({ data: [], count: 0 });
  const [article, setArticle] = useState({ data: [], count: 0 });
  const [main, setMain] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(initialPage);

  const handelSearch = (e) => getProducts(e);

  const executeScroll = () =>
    document.getElementById("article").scrollIntoView();

  /////////////get Products/////////////
  const getProducts = useCallback(async () => {
    const res = await request({
      url: getViewProductsRequest,
      values: {},
    });
    const resArticle = await request({
      url: getViewProductsRequest,
      values: {
        type: "article",
      },
    });
    const resMain = await request({
      url: getViewProductsRequest,
      values: {
        type: "page",
      },
    });

    if (res.count < 1) {
      return setProducts({
        count: res.count,
        data: [{ content: "موردی یافت نشد" }],
      });
    }
    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        today_views: items.today_views,
        total_views: items.total_views,
      }));
      setProducts({ data: transformedData, count: res.count });
    }

    if (resArticle.count < 1) {
      return setArticle({
        count: resArticle.count,
        data: [{ content: "موردی یافت نشد" }],
      });
    }
    if (resArticle) {
      let transformedData = resArticle.data.map((items) => ({
        id: items.id,
        title: items.title,
        today_views: items.today_views,
        total_views: items.total_views,
      }));
      setArticle({ data: transformedData, count: resArticle.count });
    }

    if (resMain.count < 1) {
      return setMain({
        count: resMain.count,
        data: [{ content: "موردی یافت نشد" }],
      });
    }
    if (resMain) {
      let transformedData = resMain.data.map((items) => ({
        id: items.id,
        title: items.title,
        today_views: items.today_views,
        total_views: items.total_views,
      }));
      setMain({ data: transformedData, count: resMain.count });
    }
  }, [page, request]);

  useEffect(() => {
    getProducts();
  }, [page, getProducts]);

  return (
    <DrawerCM title="آمار بازدید" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item xs={12}>
            <Button variant="outlined" onClick={executeScroll}>
              مقالات
            </Button>
          </Grid>
          <Grid item xs={12} my={2}>
            <TableCM
              title="صفحه اصلی"
              rows={main.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          <Grid item xs={12} my={2}>
            <TableCM
              title="محصولات"
              rows={products.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          <Grid item xs={12} my={2} id="article">
            <TableCM
              title="مقالات"
              rows={article.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
        </Grid>
      )}
    </DrawerCM>
  );
}
